module.exports = __webpack_public_path__ + "static/media/Sprint_DataBackup.c933b304.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/ExperienceCards/SHS-SPRINT/Sprint_DataBackup.jpg
// module id = 3762
// module chunks = 0